export const COUNTERPARTY_TIN_PROXIED_PATH_PREFIX = "/counterparty-tin";
export const COUNTERPARTY_TIN_WRITE_PATH = `${COUNTERPARTY_TIN_PROXIED_PATH_PREFIX}/write`;
export const COUNTERPARTY_TIN_REVEAL_PATH = `${COUNTERPARTY_TIN_PROXIED_PATH_PREFIX}/reveal`;
export const COUNTERPARTY_TIN_EXPORT_PATH = `${COUNTERPARTY_TIN_PROXIED_PATH_PREFIX}/export`;

export const COUNTERPARTY_TIN_GRANT_HEADER = "X-Tin-Grant";
